<template>
  <div>
    <!-- Hero Carousel -->
    <div class="hero-carousel">
      <!-- :class="{ dragging: isDragging }"
    暂时不滚动
      @mouseenter="stopAutoPlay"
      @mouseleave="onCarouselLeave"
      @mousedown="onDragStart"
      @mousemove="onDragMove"
      @mouseup="onDragEnd"
      @touchstart.passive="onTouchStart"
      @touchmove.passive="onTouchMove"
      @touchend="onDragEnd"
    
    -->
      <div class="hero-carousel-track" :style="trackStyle">
        <div
          v-for="(slide, i) in slides"
          :key="i"
          class="hero-slide"
          :style="i === currentSlide ? { backgroundImage: `url(${slide.image})` } : {}"
        >
          <div class="hero-slide-overlay"></div>
          <div class="inner-bound hero-slide-inner">
            <div class="hero-left">
              <h1 v-animate="'fadeInUp'">{{ slide.title }}</h1>
              <h1 v-animate="'fadeInUp'" class="delay-1">
                {{ slide.subtitle }}
              </h1>
              <p v-animate="'fadeInUp'" class="hero-desc delay-2">
                {{ slide.desc }}
              </p>
              <NuxtLink v-animate="'fadeInUp'" :to="slide.link" class="hero-btn text-btn delay-3">{{
                slide.btnText
              }}</NuxtLink>
            </div>
          </div>
        </div>
      </div>
      <!-- Oval indicators (bottom right) -->
      <!-- <div class="hero-indicator">
        <span
          v-for="(_, i) in slides"
          :key="i"
          class="hero-indicator-dot"
          :class="{ active: i === currentSlide }"
          @click="currentSlide = i"
        ></span>
      </div> -->
    </div>

    <!-- Promo Banner -->
    <div class="promo-banner">
      <div class="inner-bound">
        <div class="promo-banner-inner">
          <a
            v-animate="'scaleIn'"
            v-for="(item, index) in promoItems"
            :key="item.link"
            :href="item.link"
            :class="['promo-banner-item hover-lift', `delay-${index}`]"
          >
            <img :src="item.icon" :alt="item.title" class="promo-banner-icon" />
            <div>
              <h4 class="promo-banner-title">{{ item.title }}</h4>
              <p class="promo-banner-desc">{{ item.desc }}</p>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- Popular Service -->
    <div class="popular-section">
      <div class="inner-bound pt50 pb60">
        <h2 v-animate="'fadeUp'" class="popular-title">
          {{ t('home.popularService.title') }}
        </h2>
        <div class="popular-grid">
          <div
            v-animate="'scaleIn'"
            :class="['popular-card base-card hover-lift', `delay-${(index % 3) + 1}`]"
            v-for="(service, index) in popularServices"
            :key="service.name"
          >
            <div class="popular-card-header">
              <div class="popular-card-icon">
                <img :src="service.icon" :alt="service.name" />
              </div>
              <h3>
                <NuxtLink :to="localePath(service.link)">
                  {{ service.name }}<span v-if="service.subName" class="popular-sub-name">{{ service.subName }}</span>
                </NuxtLink>
              </h3>
            </div>
            <p class="popular-card-desc">{{ service.desc }}</p>
            <div class="popular-card-footer">
              <div class="popular-card-price">
                <span v-if="service.discount" class="popular-discount">{{ service.discount }}</span>
                <span class="popular-price-now"
                  >{{ service.price
                  }}<span class="popular-price-unit">{{ t('home.popularService.priceUnit') }}</span></span
                >
                <span v-if="service.oldPrice" class="popular-price-old"
                  >{{ service.oldPrice }}{{ t('home.popularService.priceUnit') }}</span
                >
              </div>
              <a :href="service.link" class="popular-buy-btn text-btn">{{ t('home.popularService.buyBtn') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Explore Tools -->
    <div class="explore-section">
      <div class="inner-bound pt50 pb60">
        <h2 v-animate="'fadeUp'" class="section-title">
          {{ t('home.exploreTools.title') }}
        </h2>
        <div v-animate="'fadeInUp'" class="explore-tabs">
          <button
            v-for="(tab, index) in exploreTabs"
            :key="tab.key"
            :class="['explore-tab text-btn', { active: activeTab === tab.key }, `delay-${index + 1}`]"
            @click="activeTab = tab.key"
          >
            {{ tab.label }}
          </button>
        </div>
        <div :key="activeTab" class="explore-content">
          <div v-animate="'fadeInLeft'" class="explore-featured base-card hover-lift">
            <div class="explore-featured-info">
              <h3>{{ currentExplore.featured.title }}</h3>
              <p>{{ currentExplore.featured.desc }}</p>
            </div>
            <a :href="currentExplore.featured.link">
              <span class="explore-btn text-btn">{{
                t('home.exploreTools.btn', {
                  title: currentExplore.featured.title
                })
              }}</span>
            </a>
          </div>
          <div class="explore-grid">
            <a
              v-animate="'scaleIn'"
              v-for="(item, index) in currentExplore.items"
              :key="item.title"
              :href="item.link"
              :class="['explore-card base-card hover-lift', `delay-${(index % 3) + 1}`]"
            >
              <div>
                <img :src="item.icon" :alt="item.title" class="explore-card-icon" />
                <h3>{{ item.title }}</h3>
                <p>{{ item.desc }}</p>
              </div>
              <span class="explore-card-link text-link">{{
                t('home.exploreTools.linkText', { title: item.title })
              }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Find Solutions -->
    <div class="solutions-section">
      <div class="inner-bound pt50 pb60">
        <h2 v-animate="'fadeUp'" class="section-title">
          {{ t('home.solutions.title') }}
        </h2>
        <div class="solutions-grid">
          <a
            v-animate="'fadeInLeft'"
            v-for="(item, index) in solutions"
            :key="item.title"
            :href="localePath(item.link)"
            :class="['solution-card base-card hover-lift', `delay-${index + 1}`]"
          >
            <div class="solution-card-img">
              <img :src="item.image" :alt="item.title" loading="lazy" />
            </div>
            <div class="solution-card-body">
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
              <div class="solution-arrow">&#8594;</div>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- Take the Next Step -->
    <div class="next-step-section">
      <div class="inner-bound pt50 pb60">
        <h2 v-animate="'fadeUp'" class="section-title">
          {{ t('home.nextStep.title') }}
        </h2>
        <div class="next-step-grid">
          <div
            v-animate="'fadeInLeft'"
            v-for="(item, index) in nextSteps"
            :key="item.title"
            :class="[
              'next-step-card base-card hover-lift',
              { 'next-step-card-wide': index === 0 },
              `delay-${index + 1}`
            ]"
          >
            <img :src="item.image" :alt="item.title" class="next-step-img" loading="lazy" />
            <div class="next-step-body">
              <h3>{{ item.title }}</h3>
              <p v-if="item.desc">{{ item.desc }}</p>
              <div class="step-btn">
                <a :href="localePath(item.link)" class="popular-buy-btn text-btn">{{ t('home.nextStep.btn') }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Discover What's Happening -->
    <div class="news-section">
      <div class="inner-bound pb60">
        <h2 v-animate="'fadeUp'" class="section-title">
          {{ t('home.news.title') }}
        </h2>
        <div class="news-grid">
          <NuxtLink
            v-animate="'fadeInLeft'"
            v-for="(item, index) in newsItems"
            :key="item.title"
            :to="item.link"
            :class="['news-card base-card hover-lift', `delay-${index + 1}`]"
          >
            <div class="news-card-img hover-scale-img">
              <img :src="item.image" :alt="item.title" loading="lazy" />
            </div>
            <div class="news-card-body">
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
              <div class="news-arrow">&#8594;</div>
            </div>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'

const { t, tm, rt, locale } = useI18n()
const localePath = useLocalePath()
const { plainTm } = usePlainTm()

const currentSlide = ref(0)
let autoTimer = null
const slideCount = 6

// Drag state
const isDragging = ref(false)
const dragStartX = ref(0)
const dragOffset = ref(0)
const DRAG_THRESHOLD = 60

const slides = computed(() =>
  Array.from({ length: slideCount }, (_, i) => ({
    title: t('home.hero.title'),
    subtitle: t('home.hero.subtitle'),
    desc: t('home.hero.desc'),
    btnText: t('home.hero.btn'),
    link: localePath('/caas'),
    image: '/static/images/home/homeBanner1.jpg'
  }))
)

const trackStyle = computed(() => {
  // if (isDragging.value && dragOffset.value !== 0) {
  //   return {
  //     transform: `translateX(calc(-${currentSlide.value * 100}% + ${dragOffset.value}px))`,
  //     transition: "none",
  //   };
  // }
  // return {
  //   transform: `translateX(-${currentSlide.value * 100}%)`,
  //   transition: "transform 0.5s ease-in-out",
  // };
})

function nextSlide() {
  currentSlide.value = (currentSlide.value + 1) % slideCount
}
function startAutoPlay() {
  stopAutoPlay()
  autoTimer = setInterval(nextSlide, 5000)
}
function stopAutoPlay() {
  if (autoTimer) {
    clearInterval(autoTimer)
    autoTimer = null
  }
}

// Mouse drag handlers
function onDragStart(e) {
  isDragging.value = true
  dragStartX.value = e.clientX
  dragOffset.value = 0
  stopAutoPlay()
}
function onDragMove(e) {
  if (!isDragging.value) return
  dragOffset.value = e.clientX - dragStartX.value
}
function onDragEnd() {
  if (!isDragging.value) return
  if (dragOffset.value > DRAG_THRESHOLD) {
    currentSlide.value = (currentSlide.value - 1 + slideCount) % slideCount
  } else if (dragOffset.value < -DRAG_THRESHOLD) {
    currentSlide.value = (currentSlide.value + 1) % slideCount
  }
  isDragging.value = false
  dragOffset.value = 0
  startAutoPlay()
}
function onCarouselLeave() {
  if (isDragging.value) {
    onDragEnd()
  }
  startAutoPlay()
}

// Touch handlers
function onTouchStart(e) {
  isDragging.value = true
  dragStartX.value = e.touches[0].clientX
  dragOffset.value = 0
  stopAutoPlay()
}
function onTouchMove(e) {
  if (!isDragging.value) return
  dragOffset.value = e.touches[0].clientX - dragStartX.value
}

onMounted(() => {
  // startAutoPlay();
})
onUnmounted(() => {
  // stopAutoPlay();
})

const promoItems = computed(() =>
  (plainTm('home.promo') || []).map((item) => ({
    ...item,
    link: localePath(item.link)
  }))
)

const popularServices = computed(() =>
  (plainTm('home.popularService.items') || []).map((item) => ({
    ...item
  }))
)

const exploreTabs = [
  { key: 'feat', label: t('home.exploreTools.tabs.feat') },
  { key: 'ssl', label: t('home.exploreTools.tabs.ssl') },
  { key: 'digital', label: t('home.exploreTools.tabs.digital') },
  { key: 'domain', label: t('home.exploreTools.tabs.domain') },
  { key: 'hosting', label: t('home.exploreTools.tabs.hosting') }
]
const activeTab = ref('feat')

const exploreData = computed(() => {
  const raw = plainTm('home.exploreTools.data') || {}
  const data = {}
  for (const key of Object.keys(raw)) {
    data[key] = {
      featured: {
        ...raw[key].featured,
        link: localePath(raw[key].featured.link)
      },
      items: (raw[key].items || []).map((item) => ({
        ...item,
        link: localePath(item.link)
      }))
    }
  }
  return data
})

const currentExplore = computed(() => exploreData.value[activeTab.value] || exploreData.value.ssl)

const solutions = computed(() =>
  (plainTm('home.solutions.items') || []).map((item) => ({
    ...item,
    link: localePath(item.link)
  }))
)

const nextSteps = computed(() =>
  (plainTm('home.nextStep.items') || []).map((item) => ({
    ...item,
    link: localePath(item.link)
  }))
)

const newsItems = computed(() =>
  (plainTm('home.news.items') || []).map((item) => ({
    ...item,
    link: localePath(item.link)
  }))
)

useHead({
  link: [
    { rel: 'preload', as: 'image', href: '/static/images/home/homeBanner1.jpg', type: 'image/jpeg' },
    { rel: 'preload', as: 'image', href: '/static/images/home/action1.jpg', type: 'image/jpeg' },
    { rel: 'preload', as: 'image', href: '/static/images/home/step1.jpg', type: 'image/jpeg' }
  ]
})

usePageSeo({
  title: t('home.seo.title'),
  description: t('home.seo.description'),
  bodyId: 'index-page'
})
</script>
